import React from 'react'
import styled from 'styled-components'
import Slide from 'react-reveal/Slide'
import Reveal from 'react-reveal/Reveal'
import Link from 'gatsby-link'
import Preview from './Preview'

const axios = require('axios')
import axiosRetry from 'axios-retry'

axiosRetry(axios, { retries: 3 })

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  padding: 1rem;
  min-height: 100vh;
  overflow: hidden;
  z-index: 0;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.15;
    z-index: -3;
  }
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    padding: 2rem;
  }
  @media (max-width: ${props => props.theme.responsive.medium}) {
    display: block;
  }
`

const Column = styled.div`
  flex: 1;
`

const EmployerForm = styled.form`
  background: white;
  border-radius: 2px;
  padding: 1rem;
  margin: 0 1rem 1rem 0;
  max-width: 800px;
  border: 1px solid ${props => props.theme.colors.tertiary};
  font-size: 1.1em;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-start;
  z-index: 99;
  position: relative;
  @media screen and (max-width: ${props => props.theme.responsive.small}) {
    margin-right: 0;
  }
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    padding: 2rem;
  }
  input[type='text'],
  input[type='email'],
  input[type='submit'],
  textarea {
    appearance: none;
    font-family: inherit;
    font-size: inherit;
    outline: none;
    background: white;
    border: 1px solid ${props => props.theme.colors.tertiary};
    color: ${props => props.theme.colors.base};
    border-radius: 2px;
    padding: 1em;
    &:focus {
      outline: none;
    }
    &:required {
      box-shadow: none;
    }
    &::-webkit-input-placeholder {
      color: gray;
    }
    &::-moz-placeholder {
      color: gray;
    }
    &:-ms-input-placeholder {
      color: gray;
    }
    &:-moz-placeholder {
      color: gray;
    }
  }
`

const Preface = styled.p`
  width: 100%;
  line-height: 1.5;
  margin: 0 0 2rem 0;
`

const City = styled.input`
  margin: 0 0 1rem 0;
  width: 100%;
  flex: 0 1 100%;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    flex: 0 1 49%;
  }
`

const PostalCode = styled.input`
  margin: 0 0 1rem 0;
  width: 100%;
  flex: 0 1 100%;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    flex: 0 1 49%;
  }
`

const FirstName = styled.input`
  margin: 0 0 1rem 0;
  width: 100%;
  flex: 0 1 100%;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    flex: 0 1 49%;
  }
`
const LastName = styled.input`
  margin: 0 0 1rem 0;
  width: 100%;
  flex: 0 1 100%;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    flex: 0 1 49%;
  }
`
const BusinessName = styled.input`
  margin: 0 0 1rem 0;
  width: 100%;
  flex: 0 1 100%;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    flex: 0 1 100%;
  }
`

const Email = styled.input`
  margin: 0 0 1rem 0;
  width: 100%;
  flex: 0 1 100%;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    flex: 0 1 100%;
  }
`

const Next = styled.input`
  margin: 0 0 1rem 0;   
  flex: 0 1 100%;
  background: ${props => props.theme.colors.base} !important;
  border: none !important;
  color: white !important;
  cursor: pointer;
  transition: 0.3s;
  &:disabled {
    background: gray !important;
    cursor: not-allowed;
  }
  &:hover {
    background: ${props => props.theme.colors.bcca} !important;
  }
`

const Submit = styled.input`
  background: ${props => props.theme.colors.base} !important;
  border: none !important;
  color: white !important;
  cursor: pointer;
  transition: 0.3s;
  &:disabled {
    background: gray !important;
    cursor: not-allowed;
  }
`

const Close = styled(Link)`
  font-weight: 600;
  display: inline-block;
  margin: 0 0 1rem 0;
  align-self: flex-end;
  transition: 0.3s;
  &:hover {
    opacity: 0.75;
  }
  @media (hover: none) {
    opacity: 1 !important;
  }
`

const Success = styled.div`
  display: ${props => props.show};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, calc(-50% - 0.5px));
  text-align: center;
  z-index: 999;
  background: white;
  border-radius: 2px;
  border: 1px solid ${props => props.theme.colors.tertiary};
  text-decoration: none;
  h2 {
    font-weight: 600;
    padding: 1rem;
    font-size: 1.25em;
    background: ${props => props.theme.colors.highlight};
    color: white;
    width: 100%;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      font-size: 1.75em;
    }
  }
  p {
    margin: 0.5rem 1.5rem;
  }
`

const SubscribeLink = styled.a`
  display: block;
  font-size: 1.1em;
  font-weight: 600;
  margin: 2rem 1rem;
  text-decoration: underline;
`

const SuccessLink = styled(Link)`
  display: block;
  font-size: 1.1em;
  font-weight: 600;
  margin: 2rem 1rem;
  text-decoration: underline;
`

const RepsText = styled.p`
  color: green;
  font-size: 0.9rem;
  width: 100%;  
`

const RepsResult = (props) => {
  if (props.isLoading) {
    return <RepsText>Searching for representatives...</RepsText>
  }
  if (!props.mla && !props.mp) {
    return <RepsText></RepsText>
  }
  if (props.mla && props.mp) {
    return (
      <RepsText>Representatives {props.mla.name} and {props.mp.name} have been added to your letter.</RepsText>
    )
  } else if (props.mla) {
    return <RepsText>Representative {props.mla.name} has been added to your letter.</RepsText>
  } else if (props.mp) {
    return <RepsText>Representative {props.mp.name} has been added to your letter.</RepsText>
  }
}

const ErrorText = styled.p`
  color: red;
  font-size: 0.9rem;
  width: 100%;
`

const Errors = (props) => {
  if (!props.message) return null

  return (
    <ErrorText>{props.message}</ErrorText>
  )
}

class Form extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      city: '',
      postalCode: '',
      firstName: '',
      lastName: '',
      email: '',
      businessName: '',
      isLoading: false,
      disabledSubmit: true,
      success: false,
      errors: null,
    }
  }

  handleInputChange = event => {
    const target = event.target
    const value = target.value
    const name = target.name
    this.setState({
      [name]: value,
    })
  }

  validatePostal = (postalCode) => {
    if (!postalCode) return null

    const ca = new RegExp(/^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][0-9][ABCEGHJ-NPRSTV-Z][0-9]$/)
    postalCode = postalCode.toString().trim()

    console.log('Testing:', postalCode)
    
    if (ca.test(postalCode.toString())) {
      console.log('Returning:', postalCode)
      return postalCode
    }

    return null
  }

  fetchRepresentatives = (event) => {
    event.preventDefault()

    let cleanPostal = this.state.postalCode.trim().toUpperCase().replace(/\W/g,'')

    this.setState({
      postalCode: cleanPostal,
      isLoading: true,
    })

    // if postal code isn't valid, return with error
    if (!this.validatePostal(cleanPostal)) {
      this.setState({
        errors: 'Invalid postal code',
        isLoading: false,
      })
      return
    } else {
      this.setState({
        errors: null
      })
    }

    console.log('Fetching MLA & MP with:', this.state.postalCode)

    axios.post('https://a7300z62o9.execute-api.us-west-2.amazonaws.com/dev/findmla', {
      postalCode: this.state.postalCode
    }, {
      headers: { 'Content-Type': 'application/json' },
    })
    .then(response => {
      console.log(response)
      
      this.setState({
        mla: response.data,
        isLoading: false,
        disabledSubmit: false
      });
    })
    .catch(error => {
      console.log(error)
    })

    axios.post('https://a7300z62o9.execute-api.us-west-2.amazonaws.com/dev/findmp', {
      postalCode: this.state.postalCode
    }, {
      headers: { 'Content-Type': 'application/json' },
    })
    .then(response => {
      console.log(response)
      
      this.setState({
        mp: response.data,
        isLoading: false,
        disabledSubmit: false
      });
    })
    .catch(error => {
      console.log(error)
    })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    console.log(this.state)

    axios.post('https://a7300z62o9.execute-api.us-west-2.amazonaws.com/dev/sendEmployer', this.state, {
      headers: { 'Content-Type': 'application/json' },
    })
    .then(response => {
      this.setState({
        city: '',
        postalCode: '',
        firstName: '',
        lastName: '',
        email: '',
        businessName: '',
        mla: '',
        mp: '',
        isLoading: false,
        disabledSubmit: true,
        success: true,
        errors:null,
      })

      fbq('track', 'SubmitApplication');
    })
    .catch(error => {
      console.log(error)
    })    
  }

  render() {
    return (
      <Wrapper>
        <Column>
          <Reveal>
            <EmployerForm
              name="postal"
              onSubmit={this.handleSubmit}
            >
              <h2>Add Your Voice:</h2>
              <Close to="/">Go Back</Close>
              <Preface>
                <strong>Step 1.</strong> Enter your Residential Town/City and Postal Code
              </Preface>
              <input type="hidden" name="form-postal" value="submit" />
              <p hidden>
                <label>
                  Don’t fill this out:{' '}
                  <input name="bot" onChange={this.handleInputChange} />
                </label>
              </p>
              <City
                name="city"
                type="text"
                placeholder="Residential City/Town"
                value={this.state.city}
                onChange={this.handleInputChange}
                required
              />
              <PostalCode
                name="postalCode"
                type="text"
                placeholder="Postal Code"
                value={this.state.postalCode}
                onChange={this.handleInputChange}
                required
              />

              <Preface>
                <strong>Step 2.</strong> Click the button below to automatically CC your local MLA &amp; MP
              </Preface>
              <Next
                disabled={!this.state.postalCode}
                name="next"
                type="submit"
                onClick={this.fetchRepresentatives}
                value="Find My Representatives"
              />
              <RepsResult mla={this.state.mla} mp={this.state.mp} isLoading={this.state.isLoading} />

              <Preface>
                <strong>Step 3.</strong> Personalize your signature
              </Preface>
              <FirstName
                name="firstName"
                type="text"
                placeholder="First Name"
                value={this.state.firstName}
                onChange={this.handleInputChange}
                required
              />
              <LastName
                name="lastName"
                type="text"
                placeholder="Last Name"
                value={this.state.lastName}
                onChange={this.handleInputChange}
                required
              />
              <BusinessName
                name="businessName"
                type="text"
                placeholder="Business Name"
                value={this.state.businessName}
                onChange={this.handleInputChange}
                required
              />
              <Email
                name="email"
                type="email"
                placeholder="Your email address to receive a copy of the letter (optional)"
                value={this.state.email}
                onChange={this.handleInputChange}
              />

              <Preface>
                <strong>Step 4.</strong> Send your Letter to Premier Horgan!
              </Preface>
              <Errors message={this.state.errors} />
              <Submit
                disabled={this.state.disabledSubmit}
                name="submit"
                type="submit"
                value="Send Letter"
              />
              
            </EmployerForm>
          </Reveal>
        </Column>

        <Column>        
          <Preview data={this.state} type='employer' />
        </Column>

        <Success show={this.state.success ? 'block' : 'none'}>
          <h2>Message Sent to the Premier</h2>
          <p>There are so many issues facing BC’s construction industry today that it can be hard to keep up. Make it easier on yourself – sign up to receive a monthly update from BCCA.</p>
          <SubscribeLink href="http://eepurl.com/dIFsxb">Sign me up</SubscribeLink>
          <SuccessLink to="/">Return Home</SuccessLink>
        </Success>
      </Wrapper>
    )
  }
}

export default Form



// WEBPACK FOOTER //
// ./src/components/Employer.js